import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigServerService, CustomHttp } from '../../../core';
import { Usuario } from '../usuario';

@Injectable({
    providedIn: 'root'
})
export class UsuarioRepresentanteHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/usuario`
    }

    /** Obtem o ID do usuário vinculado ao representante informado */
    getId(idRepresentante: number): Observable<number> {
        return this.customHttp.get<number>(`${this.pathApi}/0/representante/${idRepresentante}/id`);
    }

    /** Carrega o usuário vinculado ao representante informado */
    load(idRepresentante: number): Observable<Usuario> {
        return this.customHttp.get<Usuario>(`${this.pathApi}/0/representante/${idRepresentante}`);
    }
}
